module.exports = __webpack_public_path__ + "assets/d9b80ab47f4fe77457964b52202874b7.mp3";